/**
 * Disposition de la coquille de la plateforme : UN identifiant choisi par
 * l'exploitant dans une liste fermée.
 *
 * Contrairement aux autres familles d'apparence, ce réglage ne produit AUCUNE
 * feuille de style : il ordonne la STRUCTURE — avec la barre du haut (« barre »,
 * le rendu d'origine : marque, thème et compte en haut de page) ou sans
 * (« sans-barre » : tout remonte dans la barre latérale, qui reste toujours
 * visible ; sous 1024 px la barre revient, c'est elle qui porte le bouton du
 * menu). La structure vit dans `layouts/AppLayout.vue`, pilotée par la ref
 * `enteteAppliquee` (même patron que `densiteAppliquee`) — le CSS seul peut
 * masquer la barre, pas déplacer ses contrôles dans la latérale.
 *
 * Fonctions PURES, comme `boutons.ts`. Aucune valeur reçue ne produit du code :
 * seul l'identifiant voyage, la disposition est écrite dans ce dépôt.
 */

/**
 * Dispositions proposées. MIROIR de `STYLES_ENTETE` (backend
 * `core/apparence/schemas.ts`) et de la migration 0065 — un test backend fige
 * les trois.
 */
export const STYLES_ENTETE = ['barre', 'sans-barre'] as const
export type StyleEntete = (typeof STYLES_ENTETE)[number]

export interface EntetePlateforme {
  style?: StyleEntete
}

/** La coquille d'origine : avec la barre du haut, comme sans aucun réglage. */
export const DEFAUT_STYLE_ENTETE: StyleEntete = 'barre'

export function estStyleEntete(valeur: unknown): valeur is StyleEntete {
  return typeof valeur === 'string' && (STYLES_ENTETE as readonly string[]).includes(valeur)
}

/** Valide une forme reçue et la recopie, ou `null` si UN élément est hors contrat. */
export function normaliserEntete(brut: unknown): EntetePlateforme | null {
  if (typeof brut !== 'object' || brut === null || Array.isArray(brut)) return null
  const resultat: EntetePlateforme = {}
  for (const [cle, valeur] of Object.entries(brut)) {
    if (cle !== 'style' || !estStyleEntete(valeur)) return null
    resultat.style = valeur
  }
  return resultat
}
